import { ContentItem, Elements } from '@kentico/kontent-delivery';

/**
 * Generated by Raaz Khoshnood Manually
 * Tip: You can replace 'ContentItem' with another generated class to fully leverage strong typing.
 */
export class FundNote extends ContentItem {
  public feastName: Elements.MultipleChoiceElement;
  public englishPdf: Elements.AssetsElement;
  public persianPdf: Elements.AssetsElement;
  public png: Elements.AssetsElement;
  constructor() {
    super({
      propertyResolver: (elementName: string) => {
        if (elementName === 'feast_name') {
          return 'feastName';
        }
        if (elementName === 'english_pdf') {
          return 'englishPdf';
        }
        if (elementName === 'persian_pdf') {
          return 'persianPdf';
        }
        if (elementName === 'png') {
          return 'png';
        }
        return elementName;
      },
    });
  }
}
